<template>
  <vs-popup
    v-if="popupIsActive"
    :active.sync="popupIsActive"
    class="custom-popup"
    title=""
  >
    <vx-card>
      <div class="vx-card__title mb-4">
        <h2 class="mb-4">Новый клиент</h2>
      </div>
      <div class="mb-6">
        <div class="mb-6">
          <div class="vs-input--label">Канал: *</div>
          <v-select
            label="channel_name"
            v-model="channel"
            :clearable="false"
            :options="channels"
            v-validate="'required'"
            name="channel"
          >
            <template slot="option" slot-scope="option">
              <span class="fa" :class="option.icon"></span>
              {{ option.channel_name }} ({{option.description}})
            </template>
          </v-select>

          <span class="text-danger text-sm" v-show="errors.has('channel')">{{ errors.first('channel') }}</span>
        </div>
        <div class="mb-6">
          <div class="vs-input--label">Шаблон: *</div>
          <v-select
            label="name"
            v-model="template"
            :clearable="false"
            :options="channel.templates"
            v-validate="'required'"
            name="template"
          >
            <template slot="option" slot-scope="option">
              <span class="fa" :class="option.icon"></span>
              {{ option.name }}
            </template>
          </v-select>

          <span class="text-danger text-sm" v-show="errors.has('template')">{{ errors.first('template') }}</span>
        </div>
        <div class="mb-6">
          <vs-input
            class="w-full"
            label="Телефон: *"
            name="phone"
            v-model="phone"
            v-validate="'required'"
            v-mask="'+7 (###) ###-##-##'"
            placeholder="+7 (999) 999-99-99"
          />
          <span class="text-danger text-sm" v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
        </div>
        <div class="mb-6">
          <label class="vs-input--label">Cообщение: *</label>
          <vs-textarea
            label=""
            placeholder="Добрый день"
            rows="5"
            name="body"
            :value="body"
            v-validate="'required'"
            :readonly="true"
          />
          <span class="text-danger text-sm" v-show="errors.has('body')">{{ errors.first('body') }}</span>
        </div>
        <label v-if="templateValues.length" class="vs-input--label">Поля шаблона: *</label>
        <div class="mb-6" v-for="(_, i) in templateValues" :key="i">
          <vs-input
            :name="`template-${i}`"
            v-model="templateValues[i]"
            v-validate="'required'"
          />
          <span class="text-danger text-sm" v-show="errors.has(`template-${i}`)">{{ errors.first(`template-${i}`) }}</span>
        </div>
        <div class="flex justify-end">
            <vs-button
              id="button-with-loading"
              ref="loadableButton"
              class="mb-2 vs-con-loading__container"
              @click.prevent="handleClickSend"
            >
              Написать
            </vs-button>
        </div>
      </div>
      <div class="text-danger flex items-center" v-if="errorMessage">
        <vs-icon icon-pack="feather" icon="icon-alert-circle" class="mr-2"></vs-icon>
        {{ errorMessage }}
      </div>
      <div class="text-warning" v-if="warningMessage">
        <vs-icon icon-pack="feather" icon="icon-alert-circle" class="mr-2"></vs-icon>{{ warningMessage }}<br>
        <vs-button @click.prevent="openChat" class="mt-2">Перейти в чат</vs-button>
      </div>
    </vx-card>
  </vs-popup>
</template>

<script>
import ChatFirst from '@/api/http/models/ChatFirst'
import errorsParsing from '@/mixins/errorsParsing'
import { mapGetters } from 'vuex'

export default {
  props: {
    channels: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      popupIsActive: false,
      again: false,
      errorMessage: '',
      warningMessage: '',
      chatId: null,

      channel: this.channels[0],
      template: undefined,
      phone: '',
      templateValues: []
    }
  },

  computed: {
    ...mapGetters(['authUserCompany']),

    phoneRaw () {
      return this.phone.replace(/\+|\(|\)|-| /g, '')
    },

    body () {
      if (!this.template) {
        return
      }

      let i = 0
      return this.template.template.replace(/{{.+}}/g, () => {
        return this.templateValues[i++]
      })
    }
  },

  mixins: [errorsParsing],

  watch: {
    ['template.template'] (value) {
      this.templateValues = value.match(/{{.+}}/g).map((v) => v)
    }
  },

  methods: {
    async handleClickSend () {
      const validate = await this.$validator.validateAll()

      if (validate) {
        this.$vs.loading({
          container: '#button-with-loading',
          scale: 0.45
        })
        this.errorMessage = ''
        const response = await ChatFirst.createNewMessage(this.authUserCompany.slug, {
          transport_slug: this.channel.slug,
          phone: this.phoneRaw,
          body: this.body,
          template_name: this.template.name,
          variables: this.templateValues.map((value, i) => ({
            type: 'text',
            value,
            name: String(i + 1)
          }))
        })

        if (response.status === 'success') {
          this.$vs.notify({
            color: 'success',
            title: 'Клиент успешно добавлен',
            text: ''
          })

          if (this.again) {
            this.phone = ''
            this.body = ''
          } else {
            this.$router.push({name: 'chats', params: {client_id: response.chat_id}})
            this.popupIsActive = false
            this.$emit('close')
          }
        } else if (response.status === 'no_changes') {
          this.warningMessage = response.message
          this.chatId = response.chat_id
        } else {
          if (response.errors) {
            this.errorsParsing(response.errors)
          }
          this.errorMessage = response.message
          this.$vs.notify({
            color: 'danger',
            title: 'Произошла ошибка',
            text: ''
          })
        }

        this.$vs.loading.close('#button-with-loading > .con-vs-loading')
      }
    },

    openChat () {
      if (this.chatId) {
        document.location = `/chats/${this.chatId}`
      }
    }
  },

  async mounted () {
    this.popupIsActive = true
  }
}
</script>
